__turbopack_context__.v({
  "card": "StoryCard-module-scss-module__1ekkwa__card",
  "content": "StoryCard-module-scss-module__1ekkwa__content",
  "cta": "StoryCard-module-scss-module__1ekkwa__cta",
  "heading": "StoryCard-module-scss-module__1ekkwa__heading",
  "image": "StoryCard-module-scss-module__1ekkwa__image",
  "imageWrapper": "StoryCard-module-scss-module__1ekkwa__imageWrapper",
  "scrim": "StoryCard-module-scss-module__1ekkwa__scrim",
  "srOnly": "StoryCard-module-scss-module__1ekkwa__srOnly",
  "subheading": "StoryCard-module-scss-module__1ekkwa__subheading",
  "text": "StoryCard-module-scss-module__1ekkwa__text",
});
